<app-nav class="w-100"></app-nav>
<section class="klv-banner">
  <div class="klv-container">
    <h1 class="klv-banner-title sstarabicbold">{{ "Knowledge portal" | translator }}</h1>
  </div>
</section>

<section class="klv-page" *ngIf="!preloader">
  <div class="klv-container" *ngIf="kLibrary.length > 0 || filteredData.length > 0">
    <!-- Filters -->
    <div class="klv-panel klv-filters">
      <form class="klv-search" (ngSubmit)="handleSubmit($event)">
        <i class="pi pi-search"></i>
        <input pInputText name="search" type="text" dir="rtl" filterButton [(ngModel)]="filters.search"
          (ngModelChange)="handleFilter()" placeholder="{{ 'Search the knowledge library' | translator }}" />
      </form>
      <div class="klv-filter ppp-dropdown">
        <p-dropdown styleClass="w-100 h-100" [options]="availableExtensions" [(ngModel)]="filters.extension"
          (ngModelChange)="handleFilter()" placeholder="{{ 'File type' | translator }}" filterButton></p-dropdown>
      </div>
      <div class="klv-filter ppp-dropdown">
        <p-dropdown styleClass="w-100 h-100" [(ngModel)]="filters.ou" optionLabel="name"
          (ngModelChange)="handleFilter()" [options]="availableOus"
          placeholder="{{ 'Choose an entity' | translator }}" [filter]="true" filterButton>
          <ng-template let-node pTemplate="default">
            <div class="d-flex">
              <img *ngIf="checkisImg(node.data); else elseBlock" src="{{ staticURL }}{{ node.data }}"
                class="img-fluid p-1 tree-img-bg" style="max-height: 30px; max-width: 30px" />
              <ng-template #elseBlock>
                <i class="{{ node.image }} p-2" style="font-size: 1rem"></i>
              </ng-template>
              <b class="text-nowrap">{{ node.name }}</b>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
      <div class="klv-filter ppp-calander">
        <p-calendar styleClass="w-100 h-100" class="ppp-calander" [(ngModel)]="filters.date"
          (ngModelChange)="handleFilter()" [showIcon]="true" selectionMode="range" [readonlyInput]="true"
          placeholder="{{ 'Date' | translator }}" [inputStyle]="{ 'text-align': 'right' }" filterButton
          dir="ltr"></p-calendar>
      </div>
      <button type="button" class="klv-btn klv-btn-primary" [disabled]="!filterApplied" (click)="clearFilter()">
        <i class="pi pi-refresh"></i>{{ "Reset" | translator }}
      </button>
      <button type="button" *ngIf="hasAnyKLibraryPermission()" class="klv-btn klv-btn-primary"
        routerLink="/dashboard/knowledge-library" [pTooltip]="('Knowledge Library Content Management' | translator) + ' (' + ('Add | Edit | Delete' | translator) + ')'"
        tooltipPosition="top">
        {{ "Content Management" | translator }}
      </button>
    </div>

    <div class="klv-layout">
      <!-- Categories -->
      <aside class="klv-panel klv-categories">
        <h2 class="klv-section-title">
          {{ "Categories" | translator }}<i class="fa fa-chevron-circle-down"></i>
        </h2>
        <button type="button" *ngFor="let category of filterCategories" (click)="handleCategoryFilter(category)"
          class="w-100 {{ category == currentCategory ? 'ms-btnn' : 'ppp-ms' }}">
          <span class="klv-category-name">
            <i class="{{ category.icon }}" aria-hidden="true"></i>
            <span>{{ checkarabic(category.name) }}</span>
          </span>
          <span class="btn-numbers">{{ categoryCount[category.name] ?? 0 }}</span>
        </button>
      </aside>

      <!-- Results -->
      <div class="klv-panel klv-results">
        <div class="klv-results-toolbar">
          <div class="klv-sort ppp-dropdown">
            <p-dropdown styleClass="w-100" [options]="sortOptions" optionLabel="label" optionValue="value"
              [(ngModel)]="sortBy" (ngModelChange)="first = 0">
              <ng-template pTemplate="selectedItem" let-option>
                {{ "Sort:" | translator }} {{ option.label }}
              </ng-template>
            </p-dropdown>
          </div>
          <div class="klv-view-toggle" role="group">
            <button type="button" class="klv-icon-btn" [class.active]="viewaslist" (click)="viewaslist = true"
              [attr.aria-pressed]="viewaslist" [attr.aria-label]="'List view' | translator"
              [pTooltip]="'List view' | translator" tooltipPosition="top">
              <i class="pi pi-list"></i>
            </button>
            <button type="button" class="klv-icon-btn" [class.active]="!viewaslist" (click)="viewaslist = false"
              [attr.aria-pressed]="!viewaslist" [attr.aria-label]="'Grid view' | translator"
              [pTooltip]="'Grid view' | translator" tooltipPosition="top">
              <i class="pi pi-th-large"></i>
            </button>
          </div>
        </div>

        <div class="klv-empty" *ngIf="filteredData.length == 0">
          <i class="pi pi-search"></i>
          <span>{{ "No content matches your filters" | translator }}</span>
        </div>

        <!-- Grid view -->
        <div class="klv-grid" *ngIf="!viewaslist && filteredData.length > 0">
          <article class="klv-card" role="button" tabindex="0" *ngFor="let item of paginatedData"
            (click)="handleSelect(item)" (keydown.enter)="handleSelect(item)">
            <div class="klv-card-head">
              <div class="klv-card-heading">
                <h3 class="klv-card-title" [pTooltip]="item.name" tooltipPosition="top">{{ item.name }}</h3>
                <span class="klv-chip">{{ item.categoryname }}</span>
              </div>
              <div class="klv-type-badge" [attr.data-ext]="item.ext">
                <i class="pi pi-file"></i>
                <span>{{ item.extLabel }}</span>
              </div>
            </div>
            <p class="klv-card-ou" *ngIf="item.ou?.name">
              <b>{{ "KL entity" | translator }}:</b> {{ item.ou.name }}
            </p>
            <p class="klv-card-desc">{{ item.plainDescription }}</p>
            <div class="klv-card-foot">
              <span class="klv-meta"><i class="pi pi-calendar"></i>{{ item.dateLabel }}</span>
              <span class="klv-meta klv-meta-file">{{ item.filesLabel }}</span>
              <span class="klv-card-actions">
                <span class="klv-divider" aria-hidden="true"></span>
                <button type="button" *ngIf="itemDownloads.get(item) as progress; else idleDownload"
                  class="klv-action-btn klv-downloading" disabled [attr.aria-label]="'Loading...' | translator">
                  <i class="pi pi-spin pi-spinner"></i>
                  <span *ngIf="progress.total > 1" class="klv-download-count">{{ progress.done }}/{{ progress.total }}</span>
                </button>
                <ng-template #idleDownload>
                  <button type="button" class="klv-action-btn" [disabled]="item.downloadFiles.length == 0"
                    (click)="$event.stopPropagation(); quickDownload(item)" [attr.aria-label]="'download file' | translator"
                    [pTooltip]="'download file' | translator" tooltipPosition="top">
                    <i class="pi pi-download"></i>
                  </button>
                </ng-template>
                <button type="button" class="klv-action-btn" (click)="$event.stopPropagation(); handleSelect(item)"
                  [attr.aria-label]="'View' | translator" [pTooltip]="'View' | translator" tooltipPosition="top">
                  <i class="pi pi-eye"></i>
                </button>
              </span>
            </div>
          </article>
        </div>

        <!-- List view -->
        <div class="klv-table-wrapper" *ngIf="viewaslist && filteredData.length > 0">
          <table class="klv-table">
            <thead>
              <tr>
                <th scope="col">{{ "KL content" | translator }}</th>
                <th scope="col">{{ "KL entity" | translator }}</th>
                <th scope="col">{{ "Category" | translator }}</th>
                <th scope="col">{{ "KL file" | translator }}</th>
                <th scope="col">{{ "Date" | translator }}</th>
                <th scope="col">{{ "KL actions" | translator }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of paginatedData" (click)="handleSelect(item)">
                <td class="klv-col-content">
                  <div class="klv-content-cell">
                    <span class="klv-row-icon"><i class="pi pi-file"></i></span>
                    <div class="klv-content-text">
                      <span class="klv-row-title">{{ item.name }}</span>
                      <span class="klv-row-desc">{{ item.plainDescription }}</span>
                    </div>
                  </div>
                </td>
                <td class="klv-col-wrap">{{ item.ou?.name || "—" }}</td>
                <td class="klv-col-wrap">{{ item.categoryname }}</td>
                <td>
                  <span class="klv-file-cell">
                    <i class="pi pi-file"></i>{{ item.filesLabel }}
                  </span>
                </td>
                <td class="klv-date">{{ item.dateLabel }}</td>
                <td>
                  <span class="klv-row-actions">
                    <span class="klv-divider" aria-hidden="true"></span>
                    <button type="button" *ngIf="itemDownloads.get(item) as progress; else idleDownload"
                      class="klv-action-btn klv-downloading" disabled [attr.aria-label]="'Loading...' | translator">
                      <i class="pi pi-spin pi-spinner"></i>
                      <span *ngIf="progress.total > 1" class="klv-download-count">{{ progress.done }}/{{ progress.total }}</span>
                    </button>
                    <ng-template #idleDownload>
                      <button type="button" class="klv-action-btn" [disabled]="item.downloadFiles.length == 0"
                        (click)="$event.stopPropagation(); quickDownload(item)" [attr.aria-label]="'download file' | translator"
                        [pTooltip]="'download file' | translator" tooltipPosition="top">
                        <i class="pi pi-download"></i>
                      </button>
                    </ng-template>
                    <button type="button" class="klv-action-btn" (click)="$event.stopPropagation(); handleSelect(item)"
                      [attr.aria-label]="'View' | translator" [pTooltip]="'View' | translator" tooltipPosition="top">
                      <i class="pi pi-eye"></i>
                    </button>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <nav class="klv-pagination" *ngIf="totalPages > 1" [attr.aria-label]="'Pagination' | translator">
          <button type="button" class="klv-page-btn" [disabled]="currentPage == 1" (click)="goToPage(1)"
            [attr.aria-label]="'First page' | translator"><i class="pi pi-angle-double-right"></i></button>
          <button type="button" class="klv-page-btn" [disabled]="currentPage == 1" (click)="goToPage(currentPage - 1)"
            [attr.aria-label]="'Previous page' | translator"><i class="pi pi-angle-right"></i></button>
          <ng-container *ngFor="let page of pageNumbers">
            <span class="klv-page-gap" *ngIf="page == -1">…</span>
            <button type="button" *ngIf="page != -1" class="klv-page-btn" [class.active]="page == currentPage"
              [attr.aria-current]="page == currentPage ? 'page' : null" (click)="goToPage(page)">{{ page }}</button>
          </ng-container>
          <button type="button" class="klv-page-btn" [disabled]="currentPage == totalPages"
            (click)="goToPage(currentPage + 1)" [attr.aria-label]="'Next page' | translator"><i
              class="pi pi-angle-left"></i></button>
          <button type="button" class="klv-page-btn" [disabled]="currentPage == totalPages"
            (click)="goToPage(totalPages)" [attr.aria-label]="'Last page' | translator"><i
              class="pi pi-angle-double-left"></i></button>
        </nav>
      </div>
    </div>
  </div>
  <div class="klv-container klv-empty-actions" *ngIf="kLibrary.length == 0 && filteredData.length == 0 && hasAnyKLibraryPermission()">
    <button type="button" class="klv-btn klv-btn-primary" routerLink="/dashboard/knowledge-library"
      [pTooltip]="('Knowledge Library Content Management' | translator) + ' (' + ('Add | Edit | Delete' | translator) + ')'"
      tooltipPosition="top">
      {{ "Content Management" | translator }}
    </button>
  </div>
  <app-no-data *ngIf="!preloader && kLibrary.length == 0"></app-no-data>
</section>

<app-skelitions [hidden]="!preloader" [value]="4"></app-skelitions>

<!-- Download Dialog -->
<p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="showDownload"
  [style]="{ width: '95vw', maxWidth: '1400px' }" (onHide)="onDownloadDialogClose()">
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">{{ selectedItem.name }}</span>
  </ng-template>
  <div class="row">
    <div class="col-md-4 col-12 col-4-ui">
      <div style="display: flex; gap: 5px; align-items: center">
        <i class="color-grey m-l-2 {{ selectedItem.categoryicon }}"></i>
        <p class="m-0">{{ selectedItem.categoryname }}</p>
      </div>
      <p [innerHTML]="selectedItem.description"></p>
      <img alt="Image" src="{{ staticURL + selectedItem.image }}"
        style="max-height: 55px; max-width: 55px; border-radius: var(--border-radius-15)" />
      <p>
        {{ selectedItem.createdDate | date }}
      </p>
      <hr class="hr color-grey" />
      <div class="">
        <div role="button" (click)="handleChangeLink(file)" class="v4-not-activated {{
            file == selectedLink ? 'v4-actived' : ''
          }}" style="gap: 5px" *ngFor="let file of selectedItem.link">
          <i class="{{ getFileIcon(file.link) }} {{
              file == selectedLink ? 'text-lightt' : ''
            }}"></i>
          <p class="my-2 v4-color-white text-nowrap overflow-hidden text-truncate {{
              file == selectedLink ? 'text-lightt' : ''
            }}">
            {{ file.name }}
          </p>
        </div>
      </div>
    </div>
    <div *ngIf="selectedLink != null && selectedLink != undefined"
      class="col-md-8 col-12">
      <div class="col-8-ui">
      <div *ngIf="showingimage" class="modal-imgg-div d-flex justify-content-center">
        <img class="modal-imgg" src="{{ showingimagelink }}" alt="loading..." />
      </div>
      <div #parent *ngIf="playingYoutubeVideo && youtubeVideoId != null" style="width: 100%; height: 65vh; border-radius:var(--border-radius-15);">
        <youtube-player [height]="parent.clientHeight" [width]="parent.clientWidth" [videoId]="youtubeVideoId"
          (ready)="savePlayer($event)" (change)="onStateChange($event)">
        </youtube-player>
      </div>
      <div *ngIf="playingvideo" class="player-wrapper w-100 video-radius" dir="ltr">
        <video *ngIf="videolink" class="w-100 video-ui" controls>
          <source [src]="videolink" [type]="videoExtension === 'm4v' ? 'video/mp4' : 'video/' + videoExtension" />
          {{ "Your browser does not support this type of video" | translator }}
        </video>
      </div>
      <div *ngIf="showingpdf && !showingppt" class="w-100">
        <object [data]="showPdf()" type="application/pdf" style="
            width: 100%;
            height: 65vh;
            display: block;
            background: var(--color-text-white);
            border-radius: var(--border-radius-15);
          ">
          <a [href]="staticURL + selectedLink.link">{{
            "Download file.pdf" | translator
            }}</a>
        </object>
      </div>
      <div *ngIf="showingppt" class="w-100">
        <iframe [src]="getPptViewerUrl()" frameborder="0" allowfullscreen
          style="
            width: 100%;
            height: 65vh;
            display: block;
            background: var(--color-text-white);
            border-radius: var(--border-radius-15);
          "></iframe>
      </div>
      <!-- No inline preview for this type: a sized icon and the file name. -->
      <div [hidden]="
          playingvideo ||
          showingpdf ||
          showingppt ||
          showingimage ||
          playingYoutubeVideo
        " class="kl-file-placeholder">
        <i class="{{ getFileIcon(selectedLink.link) }}"></i>
        <span>{{ selectedLink.name }}</span>
      </div>
    </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="modal-btn mx-2">
      <a *ngIf="!pdfloading" [href]="staticURL + selectedLink.link" target="_blank">
        <button class="v4-btn-every kl-file-btn" [attr.title]="'Open in new tab' | translator" [attr.aria-label]="'Open in new tab' | translator">
          <img aria-hidden="true" class="research-icon" src="../../../../../assets/icones-2025/investigation.png" alt="">
          <!-- <i class="pi pi-folder" aria-hidden="true"></i> -->
<!-- <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
     viewBox="0 0 24 24"
     fill="none"
     stroke="white"
     stroke-width="1.5"
     width="22"
     height="22">

  <path stroke-linecap="round" stroke-linejoin="round"
        d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m5.231 13.481L15 17.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v16.5c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Zm3.75 11.625a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"/>
</svg> -->
          <!-- {{ "Open in new tab" | translator }} -->
        </button>
      </a>
      <button class="v4-btn-every kl-file-btn" (click)="downloadFile(selectedLink)" [attr.title]="'download file' | translator" [attr.aria-label]="'download file' | translator">
        <i class="pi pi-download"></i>
        <!-- {{ "download file" | translator }} -->
      </button>
    </div>
  </ng-template>
</p-dialog>
<app-footer></app-footer>